<template>
  <label class="c-label c:row-start-center" :for="labelFor">
    <div id="c-label"><slot /></div>
    <img
      v-if="required"
      class="required-icon"
      src="@/assets/icons/required.svg"
      alt=""
    />
  </label>
</template>

<script>
export default {
  props: {
    required: Boolean,
    labelFor: { type: String, default: "--a-nonexistent-input--" },
  },
};
</script>

<style lang="less" scoped>
.c-label {
  gap: 6/20rem;

  height: 17/20rem;
  margin-bottom: 10/20rem;
  line-height: 17/20rem;
  font-weight: 400;
  font-size: 12/20rem;
  letter-spacing: 0;
  color: #5e5e5e;

  .required-icon {
    width: 5/20rem;
    height: 5/20rem;
  }
}
</style>
